/* @flow */

import 'url-search-params-polyfill'

export const objectToParams = (object: Object): string => {
  const searchParams = new URLSearchParams()
  Object.keys(object).forEach((key) => {
    const value = object[key]
    if (value != null) {
      searchParams.set(key, value)
    }
  })
  return searchParams.toString()
}

export const urlParams = (string: string): Object => {
  const params = {}
  const searchParams = new URLSearchParams(string)
  for (let pair of searchParams.entries()) {
    params[pair[0]] = pair[1]
  }
  return params
}
